export enum OrderLineActionTypes {
    API_RESPONSE_SUCCESS = '@@orderLines/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@orderLines/API_RESPONSE_ERROR',

    FIND_ORDERLINE = '@@orderLines/FIND_ORDERLINE',
    UPDATE_ORDERLINE = '@@orderLines/UPDATE_ORDERLINE',
    DELETE_ORDERLINE = '@@orderLines/DELETE_ORDERLINE',
    CREATE_ORDERLINE = '@@orderLines/CREATE_ORDERLINE',
}
